export interface CountryRestriction {
    key: 'real_money' | 'age'
    age?: number
}

export type AskAboutRestrictions = (restrictions: CountryRestriction[]) => Promise<boolean>;

const acknowledgedCountries = new Set<string>();

export const showsAvailableActivities = (restrictions: CountryRestriction[]): boolean => restrictions
    .some(({key}) => key === 'real_money');

export const confirmCountryChoice = async(
    countryCode: string,
    restrictions: CountryRestriction[],
    ask: AskAboutRestrictions
): Promise<boolean> => {
    if (!countryCode || restrictions.length === 0 || acknowledgedCountries.has(countryCode)) {
        return true;
    }

    const confirmed = await ask(restrictions);

    if (confirmed) {
        acknowledgedCountries.add(countryCode);
    }

    return confirmed;
};

export const resetAcknowledgedCountries = (): void => {
    acknowledgedCountries.clear();
};
